import { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, makeStyles } from '@material-ui/core';
import { ReactComponent as RequestedIcon } from '../../../assets/icons/person-search.svg';
import { isDateInPast } from '../../../utility/dateUtils';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    boxSizing: 'border-box',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    padding: spacing(0, 2),
    fontSize: 10,
    lineHeight: '12px',
    textTransform: 'uppercase',
    textAlign: 'center',
    width: 'fit-content',
    userSelect: 'none',
    height: 20,
  },
  pending: {
    background: primary.beige1,
    color: primary.orange1,
  },
  upcoming: {
    background: primary.blue11,
    color: primary.blue2,
  },
  past: {
    background: primary.green16,
    color: primary.green15,
  },
  requested: {
    backgroundColor: primary.white,
    border: `1px solid ${primary.bluish1}`,
    color: primary.bluish1,
  },
  icon: {
    width: 12,
    height: 12,
    flexShrink: 0,
    marginRight: spacing(1),
  },
}));

const OneOnOneTimeIndicator = ({
  labels,
  meetingTime = null,
  hasImpression = false,
}) => {
  const classes = useStyles();
  const isPastOneOnOne = isDateInPast(meetingTime);
  const isRequested = meetingTime === null;

  const status = useMemo(() => {
    if (isRequested) {
      return labels.requested;
    } else if (!isPastOneOnOne) {
      return labels.upcoming;
    } else if (isPastOneOnOne && hasImpression) {
      return labels.past;
    }
    return labels.pending;
  }, [labels, isRequested, isPastOneOnOne, hasImpression]);

  return (
    <div>
      <Typography
        className={classNames(classes.root, classes.pending, {
          [classes.requested]: isRequested,
          [classes.past]: isPastOneOnOne && hasImpression,
          [classes.upcoming]: meetingTime && !isPastOneOnOne,
        })}
        variant="overline"
        component="div"
      >
        {isRequested && <RequestedIcon className={classes.icon} />}
        {status}
      </Typography>
    </div>
  );
};

OneOnOneTimeIndicator.propTypes = {
  labels: PropTypes.object.isRequired,
  meetingTime: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  hasImpression: PropTypes.bool,
};

export default OneOnOneTimeIndicator;
